import { Button, TextField, Typography } from "@king-ict/eupisi-ui/components";
import { ReactComponent as AddIcon } from "@king-ict/eupisi-ui/components/Icon/Add.svg";
import { ReactComponent as RemoveIcon } from "@king-ict/eupisi-ui/components/Icon/RemoveIcon.svg";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { Competence } from "../../models/ProgramRequest";
import { createCompetenceInitial } from "../../models/ProgramRequest/Competence";
import styles from "./ProgramRequestEdit.module.scss";

export interface CompetenceInfoProps {
  name: string;
  competences: Competence[];  
  getErrorForPath: (path: string) => string | undefined;
  onChange: (e: any) => void;
}

/** Renders a title row, a editable row for each competence, and 
 * a row to add a new competence.
 */
export function CompetenceInfo({
  name,
  competences = [],  
  getErrorForPath,
  onChange
}: CompetenceInfoProps) {
  const { t } = useTranslation();

  const handleAdd = (event: React.MouseEvent<any, MouseEvent>) => {
    var newList = competences.slice();
    newList.push(createCompetenceInitial());
    onChange({
      ...event,
      target: {
        ...event.target,
        name: name,
        value: newList
      }
    });
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    var newList = competences.slice();
    newList[index].name = event.target.value;
    onChange({
      ...event,
      target: {
        ...event.target,
        name: name,
        value: newList
      }
    });
  }

  const handleRemove = (event: React.MouseEvent<any, MouseEvent>, index: number) => {
    var newList = competences.slice();
    newList.splice(index, 1);
    onChange({
      ...event,
      target: {
        ...event.target,
        name: name,
        value: newList
      }
    });
  }

  return (
    <>
      <Row>
        <Col md={12} className={styles.rowTitleSpacing}>
          <Typography variant="smallHeading" component="h3">
            {t("request.competences")}
          </Typography>
        </Col>
      </Row>
      <Row>        
        {competences.map((comp, compIndex) => (
          <Col md={12} key={compIndex}>
            <Row>
              <Col md={12} className={"d-flex"}>
                <TextField
                  className={"w-100"}
                  label={t("request.competenceName")}
                  value={comp.name}
                  maxLength={512}
                  onChange={(e) => handleChange(e, compIndex)}
                  errorText={getErrorForPath(`competences${compIndex}.name`)}
                />
                <div className={"pl-3"} style={{ marginTop: "26px" }}>
                  <Button
                    className={`p-0 ${compIndex > 0 ? 'visible' : 'invisible'}`}
                    boxless
                    disabled={competences.length <= 1}
                    onClick={(e) => handleRemove(e, compIndex)}
                  >
                    <RemoveIcon />
                  </Button>
                </div>
              </Col>
            </Row>
          </Col>
        ))}
      </Row>
      <Row className={"text-right"}>
        <Col md={12}>
          <Button
            outline
            icon={<AddIcon />}

            onClick={handleAdd}
          >
            {t("request.competenceAdd")}
          </Button>
        </Col>
      </Row>
    </>
  );
}